import type { FC } from 'react';
import { IconButton } from '@carbon/react';
import { Add, ArrowsHorizontal, SidePanelClose, SidePanelOpen } from '@carbon/icons-react';

import { FotoDoPerfil } from './FotoDoPerfil';
import styles from './Casca.module.scss';

// A FAIXA DOS PERFIS — a coluna fina à esquerda do menu (do `md` para cima: tablet e computador): a foto de cada perfil
// da conta, para trocar de perfil num clique e ver sempre em qual se está (o aceso, com a marca da
// seleção do SideNav do Carbon). Embaixo, criar um perfil, ver todos (o ícone de troca: a pasta de
// trabalho não dizia nada, pedido do Lucas, 04/10/2026) e recolher o menu do perfil (só os ícones).
// O nome de cada perfil é a dica do botão e o nome dele para o leitor de tela.

export interface PerfilDaFaixa {
  id: string;
  nome: string;
  /** Sem foto, as iniciais. */
  imagem: string | null;
}

// `autoAlign`: a dica se posiciona pela página (floating-ui), e não fica cortada pela rolagem da
// lista nem escondida atrás do menu do perfil.

export const RailDePerfis: FC<{
  perfis: PerfilDaFaixa[];
  atual?: string;
  abrir: (id: string) => void;
  criar: () => void;
  verTodos: () => void;
  /** Só com o menu do perfil na tela. */
  menu?: { recolhido: boolean; alternar: () => void };
}> = ({ perfis, atual, abrir, criar, verTodos, menu }) => (
  <nav className={styles.faixa} aria-label='Trocar de perfil'>
    <ul className={styles.perfisDaFaixa}>
      {perfis.map((p) => (
        <li key={p.id} className={p.id === atual ? styles.perfilAceso : styles.perfilDaFaixa}>
          <IconButton
            kind='ghost'
            size='lg'
            align='right'
            autoAlign
            label={p.id === atual ? `${p.nome} (aberto)` : p.nome}
            aria-current={p.id === atual ? 'true' : undefined}
            onClick={() => abrir(p.id)}
            className={styles.botaoDaFaixa}
          >
            <FotoDoPerfil nome={p.nome} imagem={p.imagem} className={styles.fotoDaFaixa} />
          </IconButton>
        </li>
      ))}
    </ul>
    <div className={styles.acoesDaFaixa}>
      <IconButton kind='ghost' size='lg' align='right' autoAlign label='Criar perfil' onClick={criar}><Add size={20} /></IconButton>
      <IconButton kind='ghost' size='lg' align='right' autoAlign label='Todos os perfis' onClick={verTodos}><ArrowsHorizontal size={20} /></IconButton>
      {menu && (
        <IconButton
          kind='ghost'
          size='lg'
          align='right'
          autoAlign
          label={menu.recolhido ? 'Mostrar o menu do perfil' : 'Recolher o menu do perfil'}
          aria-expanded={!menu.recolhido}
          onClick={menu.alternar}
        >
          {menu.recolhido ? <SidePanelOpen size={20} /> : <SidePanelClose size={20} />}
        </IconButton>
      )}
    </div>
  </nav>
);
